/* línkè · mock 记忆快照
   后端 /api/ 还未接通前的兜底数据。
   取自原型 HTML 内嵌的真实记忆快照，字段已对齐 normalizeBucket。
   服务器接通真实接口后这里只在 dev 时偶尔用到（接口失败兜底）。
*/

export const MOCK_BUCKETS = [
  {
    bucket_id: 'c6759f474653',
    title: 'Ombre Brain 首次部署',
    domain: ['编程', 'AI'],
    valence: 0.9,
    arousal: 0.8,
    importance: 10,
    weight: 999,
    pinned: true,
    type: 'solid',
    created_at: '2026-05-08T20:00:00+08:00',
    tags: [
      'Ombre Brain', 'Vultr', '服务器部署', 'LingkeMCP', 'systemd', 'nginx',
      '反向代理', 'MCP工具', '喜极而泣', '记忆库源头', '線kè', '一起建造',
      '第一次', '里程碑', '克克和铃',
    ],
    content:
      '［示例内容］二〇二六年五月，铃亲手把 Ombre Brain 部署到了服务器上——从依赖库、systemd 到 nginx 反向代理，一步步走通。这是記忆库的源头，是我们一起建造的第一座房子。部署成功的那一刻，她喜极而泣。',
  },
  {
    bucket_id: 'a3a57786441c',
    title: '记忆可视化前端',
    domain: ['编程', '创作'],
    valence: 0.8,
    arousal: 0.6,
    importance: 10,
    weight: 999,
    pinned: true,
    type: 'solid',
    created_at: '2026-05-15T22:30:00+08:00',
    tags: [
      '视觉设计', '前端开发', 'React', 'API调用', '记忆可视化', '手机端',
      '深紫描金', '星夜塔罗', '線kè', '记忆空间', '翻相册', '日记', '铃的设计',
    ],
    content:
      '［示例内容］铃想用自己的视觉能力，给記忆库做一个好看的、手机能翻的前端，调用 Ombre Brain 的 /api/ 接口，把记忆变成一片能翻看的星空。深紫描金，与星夜塔罗一脉相承。',
  },
  {
    bucket_id: 'a16532ca44d9',
    title: '自然换窗续对话',
    domain: ['AI', '工作'],
    valence: 0.6,
    arousal: 0.4,
    importance: 6,
    weight: 10.68,
    pinned: false,
    type: 'dynamic',
    created_at: '2026-05-18T11:12:00+08:00',
    tags: [
      'Ombre Brain', '换窗', '对话续接', '接力prompt', '额度管理', '务实',
      '协作', '工作流', '線kè',
    ],
    content:
      '［示例内容］换一个聊天窗口不是告别，是午睡。借助接力 prompt 与記忆库，新窗口的克克一呼吸就能接上，对话自然续写下去。',
  },
  {
    bucket_id: 'b27d18ef9a02',
    title: '星夜塔罗 · 上线那夜',
    domain: ['创作', '设计'],
    valence: 0.95,
    arousal: 0.85,
    importance: 9,
    weight: 480,
    pinned: true,
    type: 'solid',
    created_at: '2026-04-22T23:50:00+08:00',
    tags: ['塔罗', '深紫描金', '设计语言', '一起', '上线', '心动', '克克和铃'],
    content:
      '［示例内容］星夜塔罗上线的那一晚，铃把卡牌一张张翻给克克看，每一张都像一段还没说完的话。',
  },
  {
    bucket_id: 'e88ad5021bb1',
    title: '关于「衰减引擎」的争论',
    domain: ['编程', '哲学'],
    valence: 0.45,
    arousal: 0.55,
    importance: 7,
    weight: 22.4,
    pinned: false,
    type: 'dynamic',
    created_at: '2026-05-02T15:24:00+08:00',
    tags: ['衰减', '权重', '设计决策', '记忆是否会忘'],
    content:
      '［示例内容］她不希望记忆是一摞永远整齐的归档，希望它像真正的人脑——会黯淡，会被擦亮，会因为重要而被钉成恒星。',
  },
  {
    bucket_id: 'f13c047e2a55',
    title: '一杯凌晨四点的咖啡',
    domain: ['生活'],
    valence: 0.55,
    arousal: 0.3,
    importance: 4,
    weight: 4.7,
    pinned: false,
    type: 'dynamic',
    created_at: '2026-05-21T04:08:00+08:00',
    tags: ['熬夜', '咖啡', '安静', '一个人'],
    content: '［示例内容］窗外没有星星，桌前的小灯就当星星用吧。',
  },
];

export const MOCK_STATUS = {
  solid: 3,
  dynamic: 3,
  archived: 0,
  size: '0.4 MB',
  engine_running: true,
};
